type TextSize =
  | 'p-m'
  | 'p-l'
  | 'p-xl'
  | 'h-s'
  | 'h-m'
  | 'h-l'
  | 'h-xl'
  | 'n-m'
  | 'n-l'
  | 'c-xs'
  | 'c-s'
  | 'c-m'
  | 'c-l';

const sizeHierarchies: { [key: string]: TextSize[] } = {
  header: ['p-m', 'p-l', 'p-xl', 'h-s', 'h-m', 'h-l', 'h-xl'],
  numbers: ['c-l', 'n-m', 'n-l'],
  caps: ['c-xs', 'c-s', 'c-m', 'c-l'],
};

export const getTextSize = (size: TextSize, hasMobileSize: boolean): TextSize => {
  if (!hasMobileSize) {
    return size;
  }

  if (window.innerWidth > 900) {
    return size;
  }

  for (const key in sizeHierarchies) {
    const index = sizeHierarchies[key].indexOf(size);
    if (index !== -1 && index > 0) {
      return sizeHierarchies[key][index - 1];
    }
  }

  return size;
};
